export default __webpack_public_path__ + "locales/sl/Common.json?hash=f440c88cc619cb5029d8ae44edd6e0fe";